import React from 'react'
import _ from 'lodash';
import TableContainer from 'components/TableContainer';
import { CellRenderers, getFilterProps, Sorters } from 'utils/tableUtils';
import { PermissionSetMap } from 'constants/RBACConstants';
import User from 'components/User';
import ActionMenuV2 from 'components/ActionMenuV2';
import ModalUtil from 'utils/modalUtil';
import AutomoxConfigForm from './AutomoxConfigForm';
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import message from "components/CustomMessage";

const items = [{
  type: "edit",
  permission: PermissionSetMap.EDIT_TOOL_CONFIG
}, {
  type: "delete",
  permission: PermissionSetMap.DELETE_TOOL
}]

const AutomoxListingTable = ({data, onUpdateConfigComponent, noExtras, ...props}) => {
      const onDelete = (id) => {
        const { promise } = ToolsIntegrationsAPI.deleteAutomoxConfigurations(id)
        promise.then(() => {
        message.success('Configuration deleted successfully.');
        onUpdateConfigComponent()
        })
        return promise
    }
    const onClick = async (_, record) => {
        switch(record.name){
          case "edit":
            ModalUtil.show({
				     content: <AutomoxConfigForm configData={record.data} onUpdateConfigComponent={onUpdateConfigComponent}/>,
			      })
            break;
          case "delete":
            await onDelete(record.data.id);
            break;
          default:
            break;
        }
    }

    const columns = [
        {
            title:"ID",
            dataIndex: "id",
            sorter: Sorters.NUMBER("id"),
            ...getFilterProps({
                dataIndex: "id",
                dataSource: data
            }),
            // width: 75
        },
       {
            title:"Name",
            dataIndex: "name",
            // width: 120,
            render: CellRenderers.VALUE_OR_NA
        },{
            title: "Organization Id",
            dataIndex: "orgId",
            render: CellRenderers.VALUE_OR_NA,
            // width: 100
        }, 
        {
            title: "Created By",
            dataIndex: "createdBy",
            sorter: Sorters.STRING("createdBy"),
            render: (text) => <User userEmail={text} />,
            // optional: true,
            // width: 100,
            ellipsis: true
        }, {
            title: "Created On",
            dataIndex: "createdAt",
            sorter: Sorters.DATE("createdAt"),
            render: CellRenderers.TIME_RELATIVE,
            // optional: true,
            // width: 150
        }, {
            title: "Updated On",
            dataIndex: "updatedAt",
            sorter: Sorters.DATE("updatedAt"),
            render: CellRenderers.TIME_RELATIVE,
            // width: 150
        },
        {
            title: "Action",
            key: 'action',
            dataIndex: "id",
            width: 50,
            render: (id, obj) => {
              return (
                <ActionMenuV2 items={items} onClick={onClick} data={obj} />
            )
          }
        }
    ]


    return (
       <TableContainer
            // enableScroll={true}
            loading={_.isUndefined(data)}
            columns={columns}
            dataSource={data}
            title="Configurations"
            defaultSort={{column: "createdAt", order: "descend"}}
            rowKey={"id"}
       />
    )
}

export default AutomoxListingTable;